/**
 * @author Andrés Ferreira
 * @Copyright (c) Infotrack. All rights reserved.
 */
import Tabla from '@infotrack/presentacion-componentes/tabla';
import React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { ITablaTiposMovimientosVistaProps } from '../interfaces';
import { acciones, columnas, opciones } from './constantes';

const VistaTiposMovimientos: React.FunctionComponent<ITablaTiposMovimientosVistaProps & InjectedIntlProps> = ({
    tiposMovimientoss,
    cargarTiposMovimientos,
    confirmarEliminacion,
    intl,
    manejarFormulario,
}) => (
    <div>
        <Tabla
            columns={columnas(intl.formatMessage)}
            data={tiposMovimientoss}
            actions={acciones(manejarFormulario, cargarTiposMovimientos, intl.formatMessage, confirmarEliminacion)}
            options={opciones}
        />
    </div>
);

export default injectIntl(VistaTiposMovimientos);
